import React from 'react';

import { TCard } from '@/services/requests/Recommendation/types/template4';

import { getValue } from '@/helpers/GetValueHelper';

type TModalTitleProps = {
  data: TCard;
};

export const ModalTitle = ({ data }: TModalTitleProps) => {
  return (
    <>
      <img
        className="vitrine-template4__modal-image"
        src={getValue(data, 'info_modal.image.url', '') as string}
        alt={data.info_modal.image_tag}
        width={116}
        height={116}
      />
      <h4 className="vitrine-template4__modal-title">
        {getValue(data, 'info_modal.modal_title.modal_title', '') as string}
      </h4>
    </>
  );
};
